import {Routes} from '@angular/router';
import {CpConfigPage} from './page/cp-config-page/cp-config.page';
import {CpDashboardPage} from './page/cp-dashboard-page/cp-dashboard.page';
import {
    CpProvisionDashboardStartComponent
} from './component/protected-components/cp-provision-dashboard-start/cp-provision-dashboard-start.component';
import {
    CpProvisionRunsComponent
} from './component/protected-components/cp-provision-runs/cp-provision-runs.component';
import {
    CpProvisionRunDetailComponent
} from './component/protected-components/cp-provision-run-detail/cp-provision-run-detail.component';
import {
    CpProvisionAgentsComponent
} from './component/protected-components/cp-provision-agents/cp-provision-agents.component';
import {
    CpProvisionSimulationComponent
} from './component/protected-components/cp-provision-simulation/cp-provision-simulation.component';

/**
 * Routes of the cp module (provision outgoing), 04-frontend.md §2.
 * Registered in feature-prov.routing.module.ts via getRouters().
 *
 * All paths carry the 2-letter module prefix `cp/`; only page components are routed.
 * The child routes of `cp/dashboard` are — exactly as in the bm original `bm.route.ts` (`bm/dashboard`
 * with the children start/runs/runs/:billingRunId/...) — content components of the shell page, not
 * standalone pages.
 *
 * CONFIG-001: exactly ONE config route (`cp/config`).
 * Hash routing: the URLs read `/#/cp/config`, `/#/cp/dashboard`, `/#/cp/dashboard/runs`, ...
 */
export function CpSubRoutes(): Routes {

    /**
     *
     * path:
     * Prefix of the module will always be added to the path name
     *
     *      Example
     *      path: "dashboard" => route path "cp/dashboard" !
     * ------------------------------------------------------------------
     *
     * canActivate:
     * The authentication guard MsalGuard will be added automatically!
     * ------------------------------------------------------------------
     *
     * component:
     * Added components need to be from type "Page"!
     * ------------------------------------------------------------------
     *
     */
    const routes: Routes = [
        {path: 'cp/config', component: CpConfigPage},
        {
            path: 'cp/dashboard', component: CpDashboardPage,
            children: [
                {
                    // Default child: start page with the KPI tiles per provision type (04 §3).
                    path: '',
                    component: CpProvisionDashboardStartComponent,
                },
                {
                    path: 'runs',
                    component: CpProvisionRunsComponent,
                },
                {
                    path: 'run/:provisionRunId',
                    component: CpProvisionRunDetailComponent,
                },
                {
                    path: 'agents',
                    component: CpProvisionAgentsComponent,
                },
                {
                    // Provisionssimulation: dimensions + contract start + agent in, calculation
                    // protocol out. Static child route without an `:id` (dashboard rule) — the
                    // Provisionsart is picked inside the component, not carried in the path.
                    path: 'simulation',
                    component: CpProvisionSimulationComponent,
                },
            ]
        },
    ];

    return routes;

}
